import * as actionTypes from './actionTypes';
import {addVehicle} from "./vehicles";
import axios from '../../axios';
import { copyObject } from '../../shared/utility';
import { pushVehicleImageByLink } from '../../shared/vehicle';

export const setNewVehicleData = (data, nextStep = null) => {
    if (data.hasOwnProperty('mileage')) {
        data.mileage = Number(data.mileage);
    }


    if (nextStep) nextStep();
    return {
        type: actionTypes.SET_NEW_VEHICLE,
        data
    };
};

export const uploadNewVehiclePhoto = (req, cb) => {
    
    return async dispatch => {
        const res = await axios.post(`vehicles/upload`, req, null);
        const data = res.data;
        const isSuccess = res.status === 200 && (data && !data.errors);
        const err = isSuccess ? null : (data ? data.errors : 'unknown error');
        cb && cb(err, data);
        console.log('res', res);
        //dispatch(saveNewVehiclePhoto({ key: req.key, url: data.url }));
    }
}

export const saveNewVehiclePhoto = (data) => {
    return async (dispatch, getState) => {
        const state = getState()
        state.newVehicle.images = state.newVehicle.images ? copyObject(state.newVehicle.images) : [];
        pushVehicleImageByLink(state.newVehicle, data.url, data.key);
        dispatch(setNewVehicleData({ images: state.newVehicle.images }));
    };
};

const resetNewVehicleData = () => {
    return {
        type: actionTypes.RESET_NEW_VEHICLE,
        data: {}
    };
}

export const saveNewVehicleData = (data, nextStep = null) => {
    return dispatch => {
        dispatch(setNewVehicleData(data));
        dispatch(addVehicle());
        dispatch(resetNewVehicleData());
        dispatch({type: actionTypes.RESET_BLACKBOOK})
        if (nextStep) nextStep();
    };
};